<template>
  <section>
    <cover-image
      v-if="chapter"
      :src="chapter.image"
      :title="chapter.chapterTranslations[0].title"
      :subtitle="chapter.chapterTranslations[0].editor"
      :type="'landing'"
      :editorGender="chapter.chapterTranslations[0].editorGender"
      class="no-margin"
    ></cover-image>

    <chapter-picker
      :name="'chapter'"
      :items="chapters"
      :language="language"
      :initialItem="chapter"
    ></chapter-picker>

    <div class="articles container-fluid">
      <div id="line"></div>
      <div class="row" v-for="(article, index) in articles" :key="article.id">
        <article-card
          class="col-md-6"
          :data-id="article.id"
          :article="article"
          :published="checkArticlePublishDate(article.publishDate)"
          :orientation="isOddIndex(index) ? 'left' : 'right'"
          :class="getClassesForArticle(index)"
          :inFeed="true"
        />
      </div>
    </div>

    <div class="container-fluid text-center section white" id="related" v-if="relatedResearch">
      <h4 class="section-title">Related research</h4>
    </div>

    <div class="container-fluid text-center section" id="newsletter">
      <div class="row">
        <h4 class="section-title col-12">{{ $t('title.newsletter') }}</h4>
        <p class="col-12">{{ $t('text.newsletter') }}</p>
        <div class="col-12">
          <div class="input-group col-md-6 offset-md-3">
            <input type="email" class="form-control" :placeholder="$t('placeholder.email')" />
            <span class="input-group-btn">
              <button class="btn btn-green" type="button">{{ $t('button.send') }}</button>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div id="built" class="section white">
      <div class="container">
        <div class="row" v-if="chapter.position < 15">
          <h4 class="section-title text-center col-12">{{ $t('title.built') }}</h4>
        </div>
        <div class="row logos">
          <div class="col-md-12" v-if="chapter.position < 15">
            <div class="row">
              <div class="col-md-4 offset-md-2">
                <a href="http://www.fren.org.rs" target="_blank">
                  <img src="static/logos/fren.png" alt="FREN" />
                </a>
              </div>
              <div class="col-md-4">
                <a href="http://www.secons.net" target="_blank">
                  <img src="static/logos/secons.png" alt="SeConS" v-if="language === 'en'" />
                  <img src="static/logos/secons-sr.png" alt="SeConS" v-else />
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-6 offset-md-3" v-else>
            <a href="http://www.secons.net" target="_blank">
              <img src="static/logos/secons.png" alt="SeConS" v-if="language === 'en'" />
              <img src="static/logos/secons-sr.png" alt="SeConS" v-else />
            </a>
          </div>
        </div>

        <div v-if="[9, 11, 12, 13].indexOf(chapter.position) !== -1">
          <div class="row">
            <h4 class="section-title text-center col-12">{{ $t('title.supported') }}</h4>
          </div>
          <div class="row logos">
            <div class="col-12 mt-4">
              <a
                href="http://www.fes-serbia.org"
                target="_blank"
                v-if="chapter != null && chapter.position === 9"
              >
                <img src="static/logos/fes.png" alt="Friedrich Ebert Stiftung" class="img-fluid" />
              </a>

              <a
                href="http://www.osce.org"
                target="_blank"
                v-if="chapter != null && chapter.position === 11"
              >
                <img src="static/logos/osce.png" alt="OSCE" class="img-fluid" />
              </a>

              <div class="row" v-if="chapter != null && chapter.position === 12">
                <div class="col-md-6 col-12">
                  <a href="#">
                    <img src="static/logos/ppma.png" alt="ppma" class />
                  </a>
                </div>

                <div class="col-md-6 col-12">
                  <a href="https://erasmusplus.rs/category/obrazovanje/" target="_blank">
                    <img src="static/logos/erasmus.png" alt="ppma" class />
                  </a>
                </div>
              </div>

              <a
                href="http://www.fosserbia.org"
                target="_blank"
                v-if="chapter != null && chapter.position === 13"
              >
                <img src="static/logos/fos.png" alt="FOS Srbija" class="img-fluid" />
              </a>
            </div>
          </div>
        </div>

        <div v-if="[14].indexOf(chapter.position) !== -1">
          <div class="row">
            <h4 class="section-title text-center col-12">{{ $t('title.supported') }}</h4>
          </div>
          <div class="row logos">
            <div class="col-12 mt-4">
              <a href="https://cpz.rs/" target="_blank" rel="noopener noreferrer">
                <img src="static/logos/cpz.png" alt="Centar za podršku ženama" class="img-fluid" />
              </a>
            </div>
          </div>

          <div class="row mt-5 text-center" style="font-size: 0.85rem">
            <span>
              <p>
                Teme predstavljene u ovom broju rezultat su istraživanja koje se realizuje u okviru
                projekta „Uspostavljanje informacionog sistema za prevenciju vršnjačkog nasilja – 3.
                faza“, koji sprovodi Udruženje građanki i građana “Centar za podršku ženama”, a
                finansira Ministarstvo omladine i sporta Republike Srbije.
              </p>
              <p>
                Stavovi izraženi u ovom materijalu isključiva su odgovornost autora i njegovih
                saradnika i ne predstavljaju zvaničan stav Ministarstva omladine i sporta.
              </p>
            </span>
          </div>
        </div>

        <div v-if="[15].indexOf(chapter.position) !== -1">
          <div class="row">
            <h4 class="section-title text-center col-12">{{ $t('title.supported') }}</h4>
          </div>
          <div class="row logos">
            <div class="col-4 mt-4">
              <img
                src="static/logos/nemacka-saradnja.png"
                alt="Nemačka saradnja"
                class="img-fluid"
              />
            </div>
            <div class="col-4 mt-4">
              <img src="static/logos/sdc.png" alt="SDC" class="img-fluid" />
            </div>
            <div class="col-4 mt-4">
              <img src="static/logos/giz.png" alt="GIZ" class="img-fluid" />
            </div>
          </div>

          <div class="row mt-5 text-center" style="font-size: 0.85rem">
            <span>
              {{ $t('chapters.15') }}
            </span>
          </div>
        </div>

        <div v-if="[16].indexOf(chapter.position) !== -1">
          <div class="row logos">
            <div class="col-12 mt-12">
              <img src="static/logos/c-16-logos-1.png" alt="Partneri logoi 1" class="img-fluid" />
            </div>
            <div class="col-16">
              <img src="static/logos/c-16-logos-2.png" alt="Partneri logi 2" class="img-fluid" />
            </div>
          </div>

          <div class="row mt-5 text-center" style="font-size: 0.85rem">
            <span>
              {{ $t('chapters.16') }}
            </span>
          </div>
        </div>

        <div v-if="[17].indexOf(chapter.position) !== -1">
          <div class="row mb-4">
            <h4 class="section-title text-center col-12">{{ $t('title.supported') }}</h4>
          </div>
          <div class="row logos">
            <div class="col-12 mt-12">
              <img
                src="static/logos/logo-unicef-en.png"
                alt="UNICEF"
                class="img-fluid"
                v-if="this.language === 'en'"
              />
              <img src="static/logos/logo-unicef.png" alt="UNICEF" class="img-fluid" v-else />
            </div>
          </div>

          <div class="row mt-5 text-center">
            <div class="col-md-12">
              {{ $t('chapters.17') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { CoverImage, ArticleCard, ChapterPicker } from './ui'

export default {
  name: 'landing',
  metaInfo() {
    return {
      title: this.title
    }
  },
  components: {
    CoverImage,
    ArticleCard,
    ChapterPicker
  },
  props: {
    chapter: Object,
    language: String,
    chapters: Array
  },
  data() {
    return {
      articles: null,
      relatedResearch: null,
      title: this.$t('navigation.home')
    }
  },
  created() {
    if (this.chapter != null) {
      this.getArticles()
    }

    this.$on('articleSelected', function(articleId) {
      let div = document.querySelectorAll('[data-id="' + articleId + '"]')
      console.log(div)
      div[0].scrollIntoView()
      window.scrollBy(0, -100)
    })
  },
  watch: {
    chapter: function() {
      this.getArticles()
    },
    language: function() {
      this.getArticles()
    }
  },
  methods: {
    getArticles: function() {
      this.$http.get('chapters/' + this.chapter.id + '/articles?lang=' + this.$lang).then(
        response => {
          this.articles = response.body
        },
        response => {
          console.error(response.body)
        }
      )
    },
    isOddIndex: function(index) {
      return index % 2 === 0
    },
    getClassesForArticle: function(index) {
      let classes = index === 0 ? 'first ' : ''
      classes += !this.isOddIndex(index) ? 'offset-md-6' : ''

      return classes
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/_vars.scss';

.articles {
  padding: 1rem 3rem;

  @media (max-width: $device-md) {
    padding: 1rem 2rem;
  }

  .article {
    margin-bottom: 1rem;

    @media (min-width: $device-sm) {
      margin-top: -6rem;
    }
  }

  .first {
    margin-top: 0;
  }

  #line {
    width: 1px;
    height: 95%;
    background: $feed-line-color;
    position: absolute;
    left: 50%;
    transform: translateX(-100%);
  }
}

.btn-green {
  color: $white;
  background-color: $tertiary-color;
  text-transform: uppercase;
  font-size: 0.75rem;
}

.section {
  padding: 3rem 0;

  &.white {
    background: $white;
  }
}

#related {
  border-top: 1px solid $border-color;
}

#newsletter {
  border-top: 1px solid $border-color;
  border-bottom: 1px solid $border-color;
  display: none;
}

.logos {
  margin: 0 0 1rem 0;

  img {
    display: block;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// LandingView.vue?6194a234